import React, { useMemo } from 'react';
import styled from 'styled-components';
import GraphBase from './GraphBase';
import { getResearcherText } from 'utils/constants';

const PaddedGraphBase = styled(GraphBase)`
  padding-right: 15px;
`;

export default function FocusedResearchAreas({ data, fullWidth }) {
  const invertedDataRank = useMemo(() => {
    if (!data?.data) return null;
    return { ...data, data: data.data.map((_, i) => data.data.length - i) };
  }, [data]);

  if (!invertedDataRank) return null;

  let options = baseOptions;
  if (fullWidth) {
    options = { ...baseOptions, aspectRatio: 4 };
  }

  return (
    <PaddedGraphBase
      type='horizontalBar'
      label='Top Ranked Focused Research Areas'
      data={invertedDataRank}
      options={options}
      helpText={`A list of the top Focused Research Areas found in ${getResearcherText(
        {
          isPlural: false,
          capitalized: true,
        }
      )} publications, ranked by frequency. Focused Research Areas are a standardised list of index terms, derived from a controlled list of Medical Subject Headings applied to published articles`}
      fullWidth={fullWidth}
    />
  );
}

const baseOptions = {
  legend: {
    display: false,
  },
  scales: {
    xAxes: [
      {
        ticks: {
          callback: function() {
            return null;
          },
          beginAtZero: true,
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          callback: value =>
            value?.length > 16 ? `${value.substr(0, 16)} ...` : value,
        },
      },
    ],
  },
  tooltips: {
    callbacks: {
      label: () => '',
    },
  },
};
